import { useState } from "react";
import {
  IconButton,
  Popover,
  Box,
  Typography,
  useTheme,
  alpha,
  Theme,
  Divider,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { CompactView, DetailedView, SimpleView } from "../positionableEdge";
import {
  CompactView as CompactNodeView,
  DetailedView as DetailedNodeView,
  SimpleView as SimpleNodeView,
} from "../elementNode";

const img =
  "data:image/svg+xml;base64,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";

const mockStylesElements = (theme: Theme, modeLight: boolean) => ({
  stackView: (isDown: boolean, entangled?: boolean, isCompact = true) => ({
    background: modeLight
      ? (theme.palette.background as any).paper
      : (theme.palette.background as any).paperLinkedMaps,
    padding: isCompact ? "2px 4px" : "4px 8px",
    display: "flex",
    width: "fit-content",
    flexDirection: isCompact ? "row" : "column",
    alignItems: "center",
    justifyContent: "center",
    gap: isCompact ? 0.5 : 0.3,
    borderRadius: isCompact ? 4 : 1,
    fontSize: 11,
    fontWeight: 600,
    zIndex: 1000,
    border: `1px solid ${theme.palette.divider}`,
  }),
  stackSimpleView: () => ({
    background: modeLight
      ? (theme.palette.background as any).paper
      : (theme.palette.background as any).paperLinkedMaps,
    padding: "4px 8px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5,
    borderRadius: 1,
    fontSize: 11,
    fontWeight: 600,
    width: "fit-content",
    opacity: 1,
    zIndex: 1000,
    border: `1px solid ${theme.palette.divider}`,
  }),
  interfaceLabel: () => ({
    fontSize: "11px",
    fontWeight: 600,
    color: "text.primary",
    mb: 0.5,
  }),
  layerRow: () => ({
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  }),
  metricContainer: () => ({
    display: "flex",
    alignItems: "center",
    gap: "4px",
  }),
  metricValue: () => ({
    fontSize: "11px",
    fontWeight: "bold",
    color: "text.primary",
  }),
  metricUnit: () => ({
    fontSize: "9px",
    color: "text.secondary",
  }),
  divider: () => ({
    height: "12px",
    borderColor: "divider",
  }),
  compactValue: (color: any) => ({
    fontSize: "14px",
    fontWeight: 500,
    color: color,
  }),
  detailedPaper: (
    configElement: any,
    editMode: boolean | undefined,
    colors: any,
  ) => ({
    backgroundColor: modeLight
      ? (theme.palette.background as any).paper
      : (theme.palette.background as any).paperLinkedMaps,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "6px 12px",
    gap: 1,
    borderRadius: 2,
    minWidth: "180px",
    maxWidth: "200px",
  }),
  iconBox: (
    configElement: any,
    editMode: boolean | undefined,
    colors: any,
    withBorderBottom = false,
  ) => ({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    padding: 0.8,
    backgroundColor:
      configElement?.severity === 5 && !editMode
        ? alpha(colors.background, 0.8)
        : modeLight
          ? (theme.palette.background as any).paperLinkedMaps
          : theme.palette.background.paper,
    borderRadius: 1.5,
    borderBottom: withBorderBottom
      ? `3px solid ${colors.border || theme.palette.secondary.main}`
      : undefined,
  }),
  simplePaper: (
    configElement: any,
    editMode: boolean | undefined,
    colors: any,
  ) => ({
    backgroundColor: modeLight
      ? (theme.palette.background as any).paper
      : (theme.palette.background as any).paperLinkedMaps,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: 0.5,
    gap: 1,
    borderRadius: 2,
    minWidth: "120px",
    maxWidth: "135px",
  }),
  compactPaper: (
    configElement: any,
    editMode: boolean | undefined,
    colors: any,
  ) => ({
    backgroundColor: modeLight
      ? (theme.palette.background as any).paper
      : (theme.palette.background as any).paperLinkedMaps,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    width: 50,
    height: 45,
    border: `2px solid ${colors.border || theme.palette.secondary.main}`,
  }),
  badge: (configElement: any) => ({
    position: "absolute",
    bottom: -2,
    right: -3,
    width: 13,
    height: 13,
    borderRadius: "50%",
    backgroundColor: configElement?.isDown
      ? theme.palette.error.main
      : theme.palette.success.main,
    border: `2px solid ${(theme.palette.background as any).paper}`,
  }),
  titleText: (scale = 1) => ({
    color: theme.palette.text.primary,
    fontSize: `${0.8125 * scale}rem`,
    fontWeight: 600,
    lineHeight: 1.2,
  }),
  subTitleText: (configElement: any, editMode: boolean | undefined) => ({
    color: theme.palette.text.disabled,
    fontSize: "0.6875rem",
    lineHeight: 1.2,
  }),
});

const EdgeLabelInfo: React.FC<{ theme: Theme; mockStyles: any }> = ({
  theme,
  mockStyles,
}) => (
  <>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
      Define como as informações do enlace serão exibidas no mapa. As opções
      incluem:
    </Typography>
    <ol
      style={{
        paddingLeft: 20,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        gap: 20,
      }}
    >
      <li>
        {" "}
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 500,
            mb: 1,
          }}
        >
          Detalhada:
        </Typography>
        <DetailedView
          theme={theme}
          interfaceName="GigabitEthernet1/0/2"
          isDown={false}
          editMode={false}
          configLayer={{ "preview-map": "trafego" }}
          mapId="preview-map"
          convertOutputTraffic={{
            valor: "450.5",
            unidade: "Mbps",
          }}
          convertInputTraffic={{
            valor: "1.2",
            unidade: "Gbps",
          }}
          corTrafficTx={{ cor: "#2e7d32" }}
          corTrafficRx={{ cor: "#1976d2" }}
          styles={mockStyles}
          inputPower={-12.4}
          outputPower={3.2}
          corPowerRx={{ cor: "#fff" }}
          corPowerTx={{ cor: "#fff" }}
          data={{ interface: "Gi1/0/2" }}
          entangled={false}
        />
      </li>
      <li>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 500,
            mb: 1,
          }}
        >
          Simples:
        </Typography>
        <SimpleView
          theme={theme}
          interfaceName="GigabitEthernet1/0/2"
          isDown={false}
          editMode={false}
          configLayer={{ "preview-map": "trafego" }}
          mapId="preview-map"
          convertOutputTraffic={{
            valor: "450.5",
            unidade: "Mbps",
          }}
          convertInputTraffic={{
            valor: "1.2",
            unidade: "Gbps",
          }}
          corTrafficTx={{ cor: "#2e7d32" }}
          corTrafficRx={{ cor: "#1976d2" }}
          styles={mockStyles}
          inputPower={-12.4}
          outputPower={3.2}
          corPowerRx={{ cor: "#fff" }}
          corPowerTx={{ cor: "#fff" }}
          data={{ interface: "Gi1/0/2" }}
          entangled={false}
        />
      </li>
      <li>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 500,
            mb: 1,
          }}
        >
          Compacta:
        </Typography>
        <CompactView
          theme={theme}
          interfaceName="GigabitEthernet1/0/2"
          isDown={false}
          editMode={false}
          configLayer={{ "preview-map": "trafego" }}
          mapId="preview-map"
          convertOutputTraffic={{
            valor: "450.5",
            unidade: "Mbps",
          }}
          convertInputTraffic={{
            valor: "1.2",
            unidade: "Gbps",
          }}
          corTrafficTx={{ cor: "#2e7d32" }}
          corTrafficRx={{ cor: "#1976d2" }}
          styles={mockStyles}
          inputPower={-12.4}
          outputPower={3.2}
          corPowerRx={{ cor: "#fff" }}
          corPowerTx={{ cor: "#fff" }}
          data={{ interface: "Gi1/0/2" }}
          entangled={false}
        />
      </li>
    </ol>
  </>
);

const ElementInfo: React.FC<{ theme: Theme; mockStyles: any }> = ({
  theme,
  mockStyles,
}) => {
  const mockColors = {
    border: (theme.palette as any).color.zabbixSeverty?.selected,
    background: (theme.palette as any).color.zabbixSeverty?.selectedTranslucid,
  };

  const mockConfigElement = {
    severity: 1,
    isDown: false,
  };

  const mockHosts = [
    {
      interfaces: [{ ip: "192.168.1.254" }],
    },
  ];
  return (
    <>
      <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
        Define o tipo de visualização do elemento exibido no mapa. As opções
        incluem:
      </Typography>
      <ol
        style={{
          paddingLeft: 20,
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <li>
          {" "}
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 500,
              mb: 1,
            }}
          >
            Detalhada:
          </Typography>
          <DetailedNodeView
            theme={theme}
            colors={mockColors}
            configElement={mockConfigElement}
            editMode={false}
            img={img}
            title="Roteador Core - Matriz"
            hosts={mockHosts}
            styles={mockStyles}
            descricao="Roteador principal do datacenter"
          />
        </li>
        <li>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 500,
              mb: 1,
            }}
          >
            Simples:
          </Typography>
          <SimpleNodeView
            theme={theme}
            colors={mockColors}
            configElement={mockConfigElement}
            editMode={false}
            img={img}
            title="Switch Borda 01"
            styles={mockStyles}
          />
        </li>
        <li>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 500,
              mb: 1,
            }}
          >
            Compacta:
          </Typography>
          <CompactNodeView
            theme={theme}
            colors={mockColors}
            configElement={mockConfigElement}
            editMode={false}
            img={img}
            title="Servidor"
            styles={mockStyles}
          />
        </li>
      </ol>
    </>
  );
};
const ConnectionPositionInfo = () => (
  <>
    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
      Configura os pontos de ancoragem entre os elementos no fluxo:
    </Typography>
    <ul
      style={{
        margin: 0,
        gap: "8px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <li>
        <Typography variant="body2">
          <b>Origem:</b> Define de qual lado do elemento o enlace vai partir
          (ex: Topo, Fundo, Direita, Esquerda).
        </Typography>
      </li>
      <li>
        <Typography variant="body2">
          <b>Destino:</b> Define em qual lado do elemento seguinte o enlace vai
          se conectar.
        </Typography>
      </li>
    </ul>
  </>
);

export function BaseInfoPopover({
  title,
  typeInfo,
}: {
  title: string;
  typeInfo: "edgeLabel" | "nodeLabel" | "connectionPosition";
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const theme = useTheme();
  const modeLight = theme.palette.mode === "light";
  const mockStyles = mockStylesElements(theme, modeLight);
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  const viewProps: { theme: Theme; mockStyles: any } = {
    theme,
    mockStyles,
  };
  const renderView = () => {
    switch (typeInfo) {
      case "edgeLabel":
        return <EdgeLabelInfo {...viewProps} />;
      case "nodeLabel":
        return <ElementInfo {...viewProps} />;
      case "connectionPosition":
        return <ConnectionPositionInfo />;
    }
  };
  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <InfoOutlined
          color={theme.palette.text.secondary as "secondary"}
          sx={{ fontSize: 18 }}
        />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableRestoreFocus
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            p: 0,
            maxWidth: 380,
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            backgroundColor: modeLight
              ? (theme.palette.background as any).paperLinkedMaps
              : (theme.palette.background as any).paper,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.18)}`,
            backdropFilter: "blur(8px)",
            overflow: "hidden",
            transition: "box-shadow 0.3s, border 0.3s",
          },
          onMouseLeave: handleClose,
        }}
      >
        <Box
          sx={{
            minWidth: 320,
            px: 2,
            py: 1.5,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            background: "none",
          }}
        >
          {title && (
            <>
              <Typography
                variant="subtitle1"
                fontWeight={900}
                sx={{
                  letterSpacing: 0.5,
                  color: theme.palette.primary.main,
                  fontSize: "1.15rem",
                  mb: 0.5,
                  textShadow: `0 2px 8px ${alpha(
                    theme.palette.primary.main,
                    0.08,
                  )}`,
                }}
              >
                {title}
              </Typography>
              <Divider
                sx={{ borderColor: theme.palette.primary.main, mb: 1 }}
              />
            </>
          )}
          <Box sx={{ color: theme.palette.text.primary }}>{renderView()}</Box>
        </Box>
      </Popover>
    </>
  );
}
